<template>
  <section role="main" class="content-body">
    <header class="page-header">
      <h2>聘用資料填寫</h2>
      <div class="right-wrapper">
        <ol class="breadcrumbs">
          <li>
            <a href="/">
              <i class="fa fa-home"></i>
            </a>
          </li>
          <li><span>助學金管理系統</span></li>
          <li><span>聘用資料填寫</span></li>
        </ol>
      </div>
    </header>
    <div id="tabs-0" class="row">
      <div id="tabs-03" class="row">
        <div class="col-md-12">
          <section class="panel" v-if="step==0">
            <treaty :key="$route.fullPath"></treaty>
          </section>
          <section class="panel" v-if="step==1">
            <div class="panel-body">
              <div class="form-group">
                <label class="col-md-2 control-label">學　　號：</label>
                <div class="col-md-4">{{item.studentId}}</div>
                <label class="col-md-2 control-label">姓　　名：</label>
                <div class="col-md-4">{{item.studentName}}</div>
              </div>
              <div class="form-group">
                <label class="col-md-2 control-label">性　　別：</label>
                <div class="col-md-4">{{item.studentSex}}</div>
                <label class="col-md-2 control-label">聯絡電話：</label>
                <div class="col-md-4">{{item.studentPhone}}</div>
              </div>
              <div class="form-group">
                <label class="col-md-2 control-label">身分證字號：</label>
                <div class="col-md-4">{{item.studentIDNO}}</div>
                <label class="col-md-2 control-label">出生年月日：</label>
                <div class="col-md-4">{{item.studentBirthday}}</div>
              </div>
              <div class="form-group">
                <label class="col-md-2 control-label">應聘者系所：</label>
                <div class="col-md-4">{{item.deptName}}</div>
                <label class="col-md-2 control-label">年　　級：</label>
                <div class="col-md-4">{{item.dradeClass}}</div>
              </div>
              <div class="form-group">
                <label class="col-md-2 control-label">緊急聯絡人：</label>
                <div class="col-md-4">{{item.studentParentName}}</div>
                <label class="col-md-2 control-label">關　　係：</label>
                <div class="col-md-4">{{item.studentKinship}}</div>
              </div>
              <div class="form-group">
                <label class="col-md-2 control-label">聯絡電話：</label>
                <div class="col-md-4">{{item.studentParentPhone}}</div>
              </div>
              <div class="form-group">
                <label class="col-md-2 control-label">聘僱期間：</label>
                <div class="col-md-10">{{item.workTime}}</div>
              </div>
              <div class="form-group">
                <label class="col-md-2 control-label">工作內容：</label>
                <div class="col-md-10">{{item.workContent}}</div>
              </div>
              <div class="form-group">
                <label class="col-md-2 control-label">身分/居留證正面：</label>
                <div class="col-md-4">
                  <a href="#" class="text-muted" v-if="item.identityCardPic1">
                    <span>{{item.studentName}}身分/居留證正面</span><br />
                    <img :src="item.identityCardPic1" :alt="item.studentName + '身分/居留證正面'" style="max-width:300px;" />
                  </a>
                  <input ref="identityCardPic1" type="file" v-else />
                </div>
                <label class="col-md-2 control-label">身分/居留證反面：</label>
                <div class="col-md-4">
                  <a href="#" class="text-muted" v-if="item.identityCardPic2">
                    <span>{{item.studentName}}身分/居留證反面</span><br />
                    <img :src="item.identityCardPic2" :alt="item.studentName + '身分/居留證反面'" style="max-width:300px;" />
                  </a>
                  <input ref="identityCardPic2" type="file" v-else />
                </div>
              </div>
              <div class="form-group">
                <label class="col-md-2 control-label">工作證正面 ：</label>
                <div class="col-md-4">
                  <a href="#" class="text-muted" v-if="item.workPermitPic1">
                    <span>{{item.studentName}}工作證正面</span><br />
                    <img :src="item.workPermitPic1" :alt="item.studentName + '工作證正面'" style="max-width:300px;" />
                  </a>
                  <input ref="workPermitPic1" type="file" v-else />
                </div>
                <label class="col-md-2 control-label">工作證反面 ：</label>
                <div class="col-md-4">
                  <a href="#" class="text-muted" v-if="item.workPermitPic2">
                    <span>{{item.studentName}}工作證反面</span><br />
                    <img :src="item.workPermitPic2" :alt="item.studentName + '工作證反面'" style="max-width:300px;" />
                  </a>
                  <input ref="workPermitPic2" type="file" v-else />
                </div>
              </div>
              <div class="form-group">
                <label class="col-md-2 control-label">存簿銀行代碼：</label>
                <div class="col-md-4">{{item.bankNo}}</div>
                <label class="col-md-2 control-label">存簿銀行帳號：</label>
                <div class="col-md-4">{{item.bankAccount}}</div>
              </div>
              <table width="100%">
                <tr>
                  <td align="center"><a href="#" @click.prevent="toStep2" class="btn-upload btn" style="background-color:#337AB7; border-color:#2E6DA4; color:#FFF;">下一步</a></td>
                </tr>
              </table>
            </div>
          </section>
          <section class="panel" v-if="step==2">
            <div class="panel-body">
              <table width="100%">
                <tr>
                  <td align="center" style="font-size: large;padding: 15px;">亞東學校財團法人亞東科技大學勞雇型工讀生契約書</td>
                </tr>
                <tr>
                  <td align="left" style="font-size: 14px;padding: 14px;">亞東學校財團法人亞東科技大學（以下簡稱甲方），為行政及教學單位工作執行需要，聘僱 {{item.studentName}}（以下簡稱乙方）為工讀生，有關乙方之薪資、福利等權利義務，悉依下列約定辦理：
                    <br>一、約聘期間：自{{item.contractWorkTime}}。聘期屆滿時，甲乙雙方勞動關係即自動終止，無須預告。
                    <br>二、乙方之任用資格，係約聘職務，非屬甲方之編制內人員，其年資、敘薪、福利、休假等事宜，不得要求比照編制人員。
                    <br>三、乙方職稱為 工讀生。
                    <br>四、乙方工作內容：櫃檯接待事務、接聽電話接送學生、班級點名、行政業務協助、美語事務協助、環境清潔、整理關門
                    <br>五、乙方工作時間：依甲方單位所需業務性質規定。
                    <br>六、乙方之薪資依基本時薪給付。
                    <br>七、乙方於約聘期間，由甲方提供勞工保險及依規定提撥勞工退休金等。
                    <br>八、工資之給付日期，雙方約定為次月十五日，如遇假日則延後至次個上班日發放，如遇重大事項無法如期發放，將會以書面通知乙方，並早日給付。
                    <br>九、甲方對乙方保有任用、調派、督導、考核、停聘、解聘、不續聘之權利。
                    <br>十、乙方如欲提前終止契約時，須依勞動基準法第16條預告期間規定向甲方提出書面申請。
                    <br>十一、乙方若違反本契約規定或有勞動基準法第12條情形者，甲方得不經預告終止契約。甲方若有正當理由、特殊因素、聘僱原因消失、計劃完成或經費遭刪減時得後依勞動基準法第16條預告期間規定向乙方提出預告。
                    <br>十二、其他未盡事項或任何變更，由甲乙雙方本於誠信原則另協議訂定之，若有爭訟，雙方同意以臺灣新北地方法院為管轄法院。
                    <br>十三、本契約一式二份，甲方(存聘任單位)及乙雙方各執一份為憑。
                    <br><br>立契約書人<br>
                    <br>甲方　　機構名稱：亞東學校財團法人亞東科技大學
                    　　　　　　　　 <br>　　　　校長： 黃茂全
                    　　　　　　　　 <br>　　　　地址：新北市板橋區四川路二段58號
                    　　　　　　　　 <br>　　　　電話：(02)7738-8000<br>
                    <br>乙方　　姓名：{{item.studentName}}
                    　　　　　　　　 <br>　　　　身分證字號：{{item.studentIDNO}}
                    　　　　　　　　 <br>　　　　地址：{{item.studentAddress}}
                    　　　　　　　　 <br>　　　　電話：{{item.studentPhone}}
                  </td>
                </tr>
                <tr v-if="hasData==false">
                  <td align="center" style="font-size: large;padding: 15px;"><label><input type="checkbox" v-model="check2"> 請確認是否接受以上契約內容?</label></td>
                </tr>
                <tr>
                  <td align="center">
                    <a href="#" @click.prevent="submit" v-if="hasData==false" class="btn-upload btn" style="background-color:#337AB7; border-color:#2E6DA4; color:#FFF;">送出</a>
                    <router-link to="/student" v-else class="btn-upload btn" style="background-color:#337AB7; border-color:#2E6DA4; color:#FFF;">返回</router-link>
                  </td>
                </tr>
              </table>
            </div>
          </section>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import treaty from "./treaty";

export default {
  components:{
    treaty
  },
  data() {
    return {
      item: {},
      step: -1,
      check2: false,
      hasData: false,
      hasIentityCardPic: false,
      form: {
        identityCardPic1: null,
        identityCardPic2: null,
        workPermitPic1: null,
        workPermitPic2: null
      }
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    }
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      this.$http.get("/api/workstudyStudent/employ/" + this.id).then(a => {
        this.item = a.body;
        if (this.item.workstudyEmployId) {
          this.check2 = true;
          this.hasData = true;
          this.step = 1;
        } else {
          this.step = 0;
        }
        if (this.item.identityCardPic1 && this.item.identityCardPic2) {
          this.item.identityCardPic1 = "/upload/"+this.item.identityCardPic1;
          this.item.identityCardPic2 = "/upload/"+this.item.identityCardPic2;
          this.hasIentityCardPic = true
        }
      });
    },
    toStep2() {
      if (this.hasData == false) {
        if (this.hasIentityCardPic == false) {
          this.form.identityCardPic1 = this.$refs.identityCardPic1.files[0];
          this.form.identityCardPic2 = this.$refs.identityCardPic2.files[0];
        }
        this.form.workPermitPic1 = this.$refs.workPermitPic1.files[0];
        this.form.workPermitPic2 = this.$refs.workPermitPic2.files[0];
        let msg = "";
        if (this.hasIentityCardPic == false && this.form.identityCardPic1 == null) msg += "『身分/居留證正面』、";
        if (this.hasIentityCardPic == false && this.form.identityCardPic2 == null) msg += "『身分/居留證反面』、";
        if (msg != "") {
          alert(msg.substr(0, msg.length - 1) + " 尚未選擇檔案");
          return false;
        }
      }
      this.step = 2;
    },
    submit() {
      if (this.check2 == false) {
        alert("請確認是否接受以上契約內容，\n確認後請勾選確認方塊並送出");
        return false;
      }
      let formData = new FormData();
      formData.append("identityCardPic1", this.form.identityCardPic1);
      formData.append("identityCardPic2", this.form.identityCardPic2);
      formData.append("workPermitPic1", this.form.workPermitPic1);
      formData.append("workPermitPic2", this.form.workPermitPic2);
      this.$http.post("/api/workstudyStudent/employ/" + this.id, formData, {
        headers: { "Content-Type": "multipart/form-data" }
      }).then(a => {
        if (a.body.status) {
          alert("儲存成功");
          this.$router.push("/student");
        } else {
          alert(a.body.msg);
          console.log(a.body.exstr);
        }
      });
    }
  }
};
</script>

<style>
</style>
